import { Overflow, TextOverflow, TextTransform, WhiteSpace } from "../../types";

type TextTransformObj = { textTransform: TextTransform };
type LetterSpacingObj = { letterSpacing: string };

export const capitalizeStyles: TextTransformObj = {
  textTransform: "capitalize"
};

export const uppercaseStyles: TextTransformObj & LetterSpacingObj = {
  textTransform: "uppercase",
  letterSpacing: "2px"
};

export const truncateStyles = {
  overflow: "hidden" as Overflow,
  whiteSpace: "nowrap" as WhiteSpace,
  textOverflow: "ellipsis" as TextOverflow
};
